(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider'];

    function localStorageConfig($localStorageProvider) {
        $localStorageProvider.setKeyPrefix('il-');
    }
})();
